const defaultState: any = [];

const workspacesReducer = (state = defaultState, action: { type: string; payload: any }) => {
	switch (action.type) {
		case 'SET_WORKSPACES':
			return action.payload;

		default:
			return state;
	}
};

export default workspacesReducer;
